exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-us-faranack-js": () => import("./../../../src/pages/about-us/faranack.js" /* webpackChunkName: "component---src-pages-about-us-faranack-js" */),
  "component---src-pages-about-us-javad-js": () => import("./../../../src/pages/about-us/javad.js" /* webpackChunkName: "component---src-pages-about-us-javad-js" */),
  "component---src-pages-contact-us-js": () => import("./../../../src/pages/contact-us.js" /* webpackChunkName: "component---src-pages-contact-us-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

